import { Severity, type INote } from '../models/note.model';

export class NoteHelper {
  public static calculateAggregatedNotesSeverity(notes: INote[]): Severity {
    if (notes.findIndex((n) => n.severity === Severity.high) > -1) {
      return Severity.high;
    }
    if (notes.findIndex((n) => n.severity === Severity.normal) > -1) {
      return Severity.normal;
    }
    if (notes.findIndex((n) => n.severity === Severity.low) > -1) {
      return Severity.low;
    }
    return Severity.unknown;
  }

  public static removeDuplicateNotesAndSelectOnlyText(notes: INote[]): string[] {
    return notes
      .map((item) => item.text)
      .filter((item) => item !== undefined)
      .filter((item, index, array) => array.indexOf(item) === index);
  }

  public static getNoteHeadingAndText(note: INote): { heading: string | undefined; text: string } {
    const text = note.text;
    const firstDotIndex = note.text?.indexOf('.');
    if (!text || !firstDotIndex || firstDotIndex === -1 || firstDotIndex === text?.length - 1) {
      return { heading: undefined, text: text ?? '' };
    }
    return { heading: text.substring(0, firstDotIndex + 1), text: text.substring(firstDotIndex + 1).trim() };
  }
}
